import type { Warranty } from '@/modules/product/domain/ProductDetails';
import type { IdentificationDocumentType } from '@/modules/shared/types/IdentificationDocumentType.ts';
import type shippingEvents from '@/modules/shared/utils/gtmEvents/events/shippingEvents.ts';

export type EventInteractiveTag = ShippingEventInteractiveTags | string;

export enum EEventName {
  EVENT_INTERACTIVE = 'event-interactive',
  PAGE_VIRTUAL = 'page-virtual',
  CHECKOUT = 'checkout',
  ADD_TO_CART = 'add_to_cart',
  REMOVE_FROM_CART = 'remove_from_cart'
}

export enum EWebViewNameEvent {
  ACTION_PAGE_EVENT = 'pageEvent',
  ACTION_PRE_CHECKOUT_APPLIANCE = 'begin_checkout',
  ACTION_CHECKOUT_ADD_INFO = 'add_shipping_info',
  ACTION_CHECKOUT_MEASURE_GROUPING_LEADTIME = 'measure_grouping_leadtime',
  ACTION_CHECKOUT_PRODUCTS_NOT_UNAVAILABLE_SHIPPING = 'products_not_unavailable_shipping',
  ACTION_ADD_TO_CART = 'add_to_cart',
  ACTION_REMOVE_FROM_CART = 'remove_from_cart'
}

export enum GtmEventInteractiveAction {
  Click = 'Click',
  ClickButton = 'Click Boton',
  ClickTextLink = 'Click: Text Link',
  PersonalData = 'Datos personales',
  Errors = 'Casos de errores',
  ChangePassword = 'Cambiar contraseña',
  Addresses = 'Direcciones',
  SavedCards = 'tarjetas guardadas',
  ReimburseCard = 'Datos para reembolso',
  Filter = 'Filtro',
  Sorting = 'Sorting',
  Favorites = 'Favorites',
  FavoritesDeleteProduct = 'Eliminar producto',
  FavoritesAddToCart = 'Agregar a mi carro',
  FavoritesPaginatorClick = 'Click paginador',
  GamificationRedeemCreditsButtonClick = 'Click: Botón canjear',
  GamificationRedeemCreditsCloseModal = 'Click Botón cerrar modal',
  GamificationContinueToChallengesClick = 'Click Botón seguir revisando mis desafíos',
  CencosudCardScotiabankRedirect = 'Redireccionamiento a scotiabank',
  ImageLoadError = 'Error carga de imágenes',
  Add = 'Agregar',
  Edit = 'Editar',
  Delete = 'Eliminar',
  Close = 'Cerrar',
  CouponApply = 'Aplicar Cupón',
  CouponApplyError = 'Error al aplicar cupón',
  Checkout = 'checkout',
  RefundStep1 = 'Step 1: Click botón Iniciar devolución',
  RefundStep2Success = 'Step 2: selección motivo - continuar con la devolución',
  RefundStep2Cancel = 'Step 2: selección motivo - volver al detalle de compra',
  RefundStep3Success = 'Step 3: selección unidades - continuar con la devolución ',
  RefundStep3Cancel = 'Step 3: selección unidades - volver al detalle de compra',
  RefundStep4Success = 'Step 4: selección fecha - continuar con la devolución',
  RefundStep4Cancel = 'Step 4: selección fecha - volver al paso anterior',
  RefundStep5Success = 'Step 5: añadir cuenta bancaria - continuar con la solicitud',
  RefundStep5Cancel = 'Step 5: añadir cuenta bancaria - volver al paso anterior',
  RefundStep6Success = 'Step 6: Confirmar cuenta bancaria - confirmar datos bancarios',
  RefundStep6Cancel = 'Step 6: confirmar cuenta bancaria - volver al paso anterior',
  RefundStep7Success = 'Step 7: términos y condiciones - ingresar solicitud',
  RefundStep7Cancel = 'Step 7: términos y condiciones - volver al paso anterior',
  RefundStep8Success = 'Step 8: Confirmación devolución de producto',
  RefundStep8Close = 'Step 8: clic botón volver al detalle de compra',
  RefundCDAStep1 = 'Step 1: Clic botón Iniciar devolución CDA',
  RefundCDAStep2 = 'Step 2: Redirección formulario CDA',
  RefundDetail = 'Visibilidad de detalle devolución',
  DefaultErrorMsg = 'Error genérico de respuesta',
  RecoveryPasswordStep1 = 'Step 1: Ingresar rut',
  RecoveryPasswordStep2 = 'Step 2: Restablecer Contraseña',
  RecoveryPasswordStep1Error = 'Step 1 error',
  RecoveryPasswordStep2Error = 'Step 2 error',
  GuestClickLoginButton = 'Clic botón en vista detalle',
  GuestClickLinkTest = 'Click Text link en Modal',
  GuestCleanSearcherOC = 'Buscador OC - Limpiar',
  GuestSearcherOC = 'Buscador OC - Filtro por orden de compra',
  GuestSendCode = 'Enviar codigo',
  GuestOpenModal = 'Clic Apertura modal',
  GuestSwitchAction = 'Clic botón switch',
  GuestRutConfirmation = 'Confirmar rut',
  GuestCodeValidation = 'Validar codigo',
  GuestCreateAccount = 'Crear mi cuenta',
  GuestDoItLater = 'Quiero crear mi cuenta despues',
  AddToCart = 'Agregar al carro',
  RemoveFromCart = 'Eliminar del carro',
  SeeDetailProduct = 'Ver detalle producto',
  SamplingModalRemove = 'Selección botón: eliminar productos y muestras',
  SamplingModalBack = 'Selección botón: volver al carro',
  SamplingModalClose = 'Selección botón: cerrar modal eliminar muestra gratis',
  PdpSizesGuideOpen = 'Clic link: abrir guía de tallas',
  PdpSizesGuideClose = 'Clic link: cerrar guía de tallas',
  BillingClickPayment = 'Clic pagar',
  BillingLinkToCart = 'Clic Ir a editar - carro de compra',
  BillingLinkToMultishipping = 'Clic Ir a editar - tipo de entrega',
  BillingLinkNeedInvoice = 'Clic link necesitas factura',
  BillingSaveInvoiceData = 'Clic boton guardar datos facturación',
  BillingEditCompany = 'Clic editar empresa',
  BillingDeleteCompanyButton = 'Quitar factura',
  BillingDeletedCompanySuccess = 'Clic boton eliminar',
  BillingDeleteCompanyGoBack = 'Clic boton volver',
  BillingContinueWithInvoice = 'Clic boton seguir con factura',
  BillingContinueWithReceipt = 'Clic boton seguir con boleta',
  BillingAddGiftCard = 'Agregar tarjeta gift card',
  BillingGiftCardInteraction = 'Interaccion Gift Card',
  BillingGiftCardError = 'Errores Gift Card',
  BillingPaymentErrorResponse = 'Respuesta',
  BillingClickRemoveCoupon = 'Clic intensión eliminar cupón',
  BillingRemoveCouponConfirm = 'Clic botón confirmar eliminar cupón',
  BillingRemoveCouponCancel = 'Clic botón cancelar eliminar cupón',
  BillingLoginOrRegister = 'Clic inicia sesion o registrate',
  BillingGiftCardInfoMessage = 'Mensaje informativo Gift Card',
  BillingSaveCard = 'Aceptar Guardar tarjeta',
  BillingAcceptSaveCard = 'Quiero guardar esta tarjeta',
  BillingClubParis = 'Agregar codigo programa club paris',
  BillingClubParisRemoveIntent = 'clic intencion eliminar codigo programa club paris',
  BillingClubParisRemoved = 'clic boton eliminar codigo programa club paris',
  BillingClubParisError = 'Errores Club paris',
  BillingExpiredCard = 'tarjetas guardada expirada',
  BillingMyPurchasesButton = 'Clic botón ir a mis compras',
  BillingContactForm = 'Clic link formulario de contacto',
  BillingRequestCancelation = 'Clic link solicitar una cancelación',
  BillingContactByWhatsapp = 'Clic link comunicarse a traves de whatsapp',
  BillingSelectedPaymentMethod = 'Clic seleccionar tarjeta',
  BillingErrorRestrictionsCoupon = 'Error restricciones de cupon'
}

export enum EAnalyticsShippingMethodType {
  COLLECT = 'ReT',
  SAME_DAY = 'sameday',
  NEXT_DAY = '24 hrs',
  DATE_RANGE = 'RdF',
  SCHEDULED = 'DaD'
}

export enum ShippingEventInteractiveTags {
  ModifyAddress = 'Link modificar dirección',
  Logo = 'Logo',
  Shipping = 'Despacho',
  Response = 'Respuesta',
  StepperData = 'Datos',
  StepperDelivery = 'Entrega',
  StepperBilling = 'Pago',
  EditCart = 'Editar carro',
  OpenResume = 'Abrir',
  ShowMore = 'Mostrar más',
  ArrowDiscount = 'Icono flecha - cupón de descuento',
  AddAddress = 'Click link agregar dirección',
  SaveForLater = 'Guardar para después',
  ContinueWithPayment = 'Continuar con el pago',
  AnotherPerson = 'Click botón retira otra persona',
  WhoWillPikcupConfirm = 'Click botón confirmar - modal quien hará el retiro',
  WhoWillPikcupClose = 'Click botón cerrar - modal quien hará el retiro',
  ChooseAnotherDate = 'Link elegir otra fecha',
  ClickTrashButton = 'Click icono basurero',
  StoreChanged = 'Cambiaste la tienda con éxito',
  EditProductsLink = 'Link editar productos',
  OutOfStock = 'Producto no disponible No posee ningún tipo de entrega disponible',
  ReceiveTomorrow = 'Recibe mañana',
  ReceiveToday = 'Recibe hoy',
  ReceiveBetween = 'Recibe entre',
  ClickOnPencil = 'Click icono lápiz',
  ReceiveOn = 'Recibe el',
  PencilIcon = 'Click ícono lápiz',
  ClickConfirm = 'Click botón confirmar',
  ClickChooseAnotherStore = 'Click link elegir otra tienda cencosud',
  ClickChooseAnotherCopec = 'Click link elegir otro punto blue express y copec',
  ShowProducts = 'Mostrar productos',
  CantSaveProducts = 'No pudimos guardar este producto.',
  ProductSaved = '¡Genial! Guardaste tu producto con éxito.',
  ClickCloseMyAddressesModal = 'Click cerrar modal',
  GroupsInformation = 'Información de grupos',
  OkButtonGroupsInformation = 'Botón Entendido - modal información de grupos',
  CloseButtonGroupsInformation = 'Botón cerrar - modal información de grupos',
  ClickCloseDatePickerModalButton = 'Click cerrar modal despacho',
  ShippingError = 'Error de ingreso',
  ShippingErrorTryAgain = 'Volver a intentar'
}

export enum ShippingEventInteractivePage {
  Shipping = 'shipping'
}

export enum ShippingEventInteractivePageNames {
  BuyingProcessDelivery = 'Buying Process - Type Delivery'
}

export enum ShippingEventInteractiveCategories {
  Checkout = 'Checkout shipping',
  CheckoutSummary = 'Checkout shipping summary',
  CheckoutInfo = 'Checkout Info'
}

export enum ShippingEventInteractiveActions {
  Click = 'Click',
  AddAddress = 'Respuesta - modal agregar dirección',
  Pickup = 'Respuesta - modal retiro en tienda',
  PickupNotAllowed = 'Respuesta - modal retiro en tienda no disponible',
  CopecNotAllowed = 'Respuesta - modal blue express y copec no disponible',
  ShippingMethod = 'Click selección modo de entrega',
  ClickStepper = 'Click stepper',
  AnotherPerson = 'Interacciones retira otra persona',
  DispatchIntearctions = 'Interacciones despacho',
  PickupInteractions = 'Interacciones retiro en tienda',
  CloseButtonPickupModal = 'Botón cerrar - modal retiro en tienda',
  nuevo = 'Click boton confirmar - modal retiro en tienda',
  StorePickupNotAvailable = 'Click boton confirmar - modal retiro en tienda no disponible',
  CopecPickupNotAvailable = 'Click boton confirmar - modal Blue Express y Copec no disponible',
  OutOfStock = 'Interacciones productos agotados',
  ResponseAnotherPerson = 'Respuesta - Interacciones retira otra persona',
  Response = 'Respuesta',
  CheckoutDate = 'Click fecha despacho',
  ModalConfirmDate = 'Interacciones modal despacho - Confirmar fecha',
  ModalConfirmDateInteractions = 'Interacciones modal despacho',
  ClickConfirmScheduled = 'Click confirmar horarios disponibles',
  ChangeAddress = 'Respuesta - modal Mis direcciones',
  SaveAddress = 'Click boton Guardar - modal agregar dirección',
  UpdateAddress = 'Click boton Guardar cambios - modal agregar dirección',
  ClickCopec = 'Click retiro copec',
  ChooseAnotherCopec = 'Click elegir otro punto blue express y copec',
  ClickConfirmChangeCopec = 'Click botón confirmar - modal Blue Express y Copec',
  ClickControledError = 'Errores shipping codificados',
  NotAvailableStores = 'Interacciones tiendas no disponibles',
  ModalMyAddress = 'Interacción modal Mis direcciones',
  CloseAddressModal = 'Click boton cerrar - modal agregar dirección',
  ShippingErrors = 'Errores shipping',
  TooltipInteractions = 'Interacciones tooltip',
  PickupNotAvailable = 'visualización - modal retiro en tienda no disponible'
}

type TEventName = EEventName | EWebViewNameEvent;

type Event = {
  event?: TEventName;
};

export interface GtmEvent extends Event {
  'event-interactive-category'?: ShippingEventInteractiveCategories;
  'event-interactive-accion'?: ShippingEventInteractiveActions | string;
  'event-interactive-tag'?: EventInteractiveTag;
  documentType?: IdentificationDocumentType;
}

export interface GtmEventWithGroup extends GtmEvent {
  'event-interactive-grupo_despacho'?: string;
  ecommerce?: GTMEcommerceCheckout;
}
export interface GtmEventWithLocalization extends GtmEvent {
  'event-interactive-comuna'?: string;
  'event-interactive-region'?: string;
}
export interface GtmEventPickupModal extends GtmEventWithGroup {
  'event-interactive-retiro': string;
  'event-interactive-vendedor': string; // indicar el vendido por
  'event-interactive-costo'?: string | number;
}

export interface GtmEventWithGroupAndLeadTime extends GtmEvent {
  'event-interactive-value'?: number;
  'event-interactive-leadtime_despacho'?: string;
  'event-interactive-leadtime_retiro'?: string;
  'event-interactive-leadtime_puntoscopec'?: string;
  dimension46?: string | number;
  dimension47?: string;
  'event-interactive-vendedor'?: string;
  ecommerce?: GTMEcommerceCheckout;
}

export interface GtmEventOutOfStock extends GtmEventWithGroup {
  'event-interactive-sku'?: string;
}

export interface GtmEventConfirmModalDate extends GtmEventWithGroup {
  'event-interactive-despacho'?: string;
}

export interface GtmEventPage extends Event {
  page: ShippingEventInteractivePage.Shipping;
  pagename: ShippingEventInteractivePageNames.BuyingProcessDelivery;
}

export interface GtmEventProductPerfomance extends Event {
  'type-User'?: string;
  ecommerce?: GTMEcommerceCheckout;
}

export interface GTMEcommerceCheckout {
  checkout?: {
    actionField?: GtmEcommerceActionField;
    checkoutParams?: IAnalyticsShippingDevice;
    products?: GtmEcommerceProducts[] | IWebViewGtmProduct[];
    documentType?: IdentificationDocumentType;
  };
}

export interface GtmEcommerceActionField {
  step?: string;
  option?: string;
  action?: string;
}

export interface GtmEcommerceProducts {
  id?: string;
  name?: string;
  variant?: string;
  category?: string;
  brand?: string | { key: string; label: string };
  price?: number;
  dimension2?: string | { key: string; label: string };
  dimension3?: string | { key: string; label: string };
  dimension17?: string;
  dimension32?: string | { key: string; label: string };
  dimension11?: string | { key: string; label: string };
  dimension33?: string | { key: string; label: string };
  dimension12?: string | { key: string; label: string };
  dimension18?: string | { key: string; label: string };
  dimension19?: number;
  dimension20?: number;
  dimension21?: boolean | Warranty[];
  dimension30?: string;
  dimension36?: string;
  dimension41?: string | number;
  dimension42?: number;
  metric9?: number;
  quantity?: number;
}

export type ShippingEvent =
  | GtmEvent
  | GtmEventWithGroup
  | GtmEventWithLocalization
  | GtmEventPage
  | GtmEventPickupModal
  | GtmEventWithGroupAndLeadTime
  | GtmEventOutOfStock
  | GtmEventConfirmModalDate
  | GtmEventProductPerfomance;

export type ShippingEventsType = Record<
  'baseEvent' | 'pageEvent' | 'checkout' | EWebViewNameEvent,
  ShippingEvent
>;

export type ShippingEventKeys = keyof typeof shippingEvents;

export type SendGtmEvent = {
  event: ShippingEventKeys;
  extraFields?: Partial<ShippingEvent>;
};

export interface GtmGroupsData {
  groupNumber: number | undefined;
  totalGroups: number | undefined;
}

export interface GtmData extends GtmGroupsData {
  sku?: string;
}

//Data Types for the send Event To Web View
export interface PageVirtualEvent {
  event: string;
  'type-User': string;
  page: string;
  pagename: string;
}

export interface IAnalyticsShippingDevice {
  AnalyticsParameterCurrency?: string;
  AnalyticsParameterValue?: number;
  AnalyticsParameterCoupon?: string;
  AnalyticsParameterShippingTier?: string;
  AnalyticsParameterPaymentType?: string;
  AnalyticsParameterAffiliation?: string;
  AnalyticsParameterTax?: string;
  AnalyticsParameterShipping?: string;
}

export interface IWebViewGtmProduct {
  AnalyticsParameterItemID: string;
  AnalyticsParameterItemName: string;
  AnalyticsParameterItemCategory: string;
  AnalyticsParameterItemCategory2: string;
  AnalyticsParameterItemCategory3: string;
  AnalyticsParameterItemCategory4: string;
  AnalyticsParameterItemCategory5: string;
  AnalyticsParameterItemVariant?: string;
  AnalyticsParameterItemBrand: string;
  AnalyticsParameterPrice: number;
  AnalyticsParameterQuantity: number;
}
